// extracted by css-extract-rspack-plugin
export default {"nameButton":"nameButton-VJR_Od","cellSub":"cellSub-_huEk3"};